import { Pipe, PipeTransform } from '@angular/core';
import { JobPost } from '../../jobs/models/job-post';

@Pipe({
  name: 'jobPostsFilter'
})
export class JobPostsFilterPipe implements PipeTransform {

  transform(jobPosts: JobPost[], filterText: string): JobPost[] {
    return jobPosts.filter(job => job.title.search(new RegExp(filterText, "i")) > -1);
  }

}
